import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { Wrapper, Button, useInput } from 'sputnik-ui'
import styled from 'styled-components'
import { useSelector } from 'react-redux'
import { Formik, Form } from 'formik'
import { Typography, Checkbox } from '@material-ui/core'
import { changeCompanyServicesInfo } from 'store/companies/operations'
import { getCompanyService } from 'store/companies/operations'

const Section = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 1rem;
`;

const Column = styled.div`
  width: 48%;
  display: flex;
  flex-direction: column;
`;

const ServiceItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem 1rem;
  border-bottom: 1px solid #ddd;
`;

const StyledWrapper = styled(Wrapper)`
  background: ${(p) => p.theme.palette.white['500']};
  overflow: hidden;
  flex-direction: column;
`;

const Services = ({ dispatch, services, catalog, servicesCatalogForCompany, selectedCompany }) => {
  const selectedCompanyUuid = useSelector(({ companies }) => companies.selected?.value);
  const [didUpdateValues, setDidUpdateValues] = useState(false);
  const [servicesState, setServicesState] = useState({
    services: [],
    companyServices: []
  });
  
  useEffect(() => {
    const getInitialServices = (serviceCatalog) => {
      return serviceCatalog?.map(item => ({
        service_identifier: item.identifier,
        customer_uuid: selectedCompanyUuid,
        uuid: services?.services?.find(s => s.service_config_identifier === item.identifier)?.uuid || null,
        activate: services?.services?.some(s => s.service_config_identifier === item.identifier) || false,
        initialActivate: services?.services?.some(s => s.service_config_identifier === item.identifier) || false
      })) || [];
    };

    setServicesState({
      services: getInitialServices(catalog),
      companyServices: getInitialServices(servicesCatalogForCompany)
    });
  }, [services, catalog, servicesCatalogForCompany, selectedCompanyUuid]);

  const handleUpdateCompanyServices = () => {
    const changedServices = servicesState.services.filter(service => service.activate !== service.initialActivate);
    const changedCompanyServices = servicesState.companyServices.filter(service => service.activate !== service.initialActivate);

    dispatch(
      changeCompanyServicesInfo({
        companyUuid: selectedCompanyUuid,
        services: changedServices.concat(changedCompanyServices),
      }),
    ).then(() => {
      dispatch(getCompanyService(selectedCompanyUuid));
    }).catch(() => {
      dispatch(getCompanyService(selectedCompanyUuid));
    });

    setDidUpdateValues(false);
  };

  const changeServiceActivation = (serviceIdentifier, activate, isCompanyService = false) => {
    setServicesState(prev => {
      const key = isCompanyService ? 'companyServices' : 'services';
      return {
        ...prev,
        [key]: prev[key].map(service => 
          service.service_identifier === serviceIdentifier 
            ? { ...service, activate } 
            : service
        )
      };
    });
    
    setDidUpdateValues(true);
  };

  const isServiceActive = (serviceIdentifier, isCompanyService = false) => {
    const servicesArray = isCompanyService ? servicesState.companyServices : servicesState.services;
    const service = servicesArray.find(s => s.service_identifier === serviceIdentifier);
    return service ? service.activate : false;
  };

  return (
    <Formik initialValues={{}} enableReinitialize onSubmit={handleUpdateCompanyServices}>
      <Form>
        <Typography variant="h5" gutterBottom>
          Список возможных подключений
        </Typography>
        <StyledWrapper style={{ marginBottom: '1rem', flexDirection: 'column' }}>
          {didUpdateValues && (
            <Button rounded primary style={{ marginRight: 'auto' }} type="button" onClick={handleUpdateCompanyServices}>
              обновить данные
            </Button>
          )}
        </StyledWrapper>

        <Section>
          <Column>
            <Typography variant="h6">Тарифы</Typography>
            {catalog?.map((item) => (
              <ServiceItem key={item.title}>
                <span>{item.title}</span>
                <Checkbox
                  checked={isServiceActive(item.identifier)}
                  onChange={(e) => changeServiceActivation(item.identifier, e.target.checked)}
                />
              </ServiceItem>
            ))}
          </Column>

          <Column>
            <Typography variant="h6">Опции для компании</Typography>
            {servicesCatalogForCompany?.map((item) => (
              <ServiceItem key={item.title}>
                <span>{item.title}</span>
                <Checkbox
                  checked={isServiceActive(item.identifier, true)}
                  onChange={(e) => changeServiceActivation(item.identifier, e.target.checked, true)}
                />
              </ServiceItem>
            ))}
          </Column>
        </Section>
      </Form>
    </Formik>
  );
};

const mapStateToProps = ({ companies }) => ({
  services: companies.services,
  selectedCompany: companies.selected,
  catalog: companies.servicesCatalog,
  servicesCatalogForCompany: companies.servicesCatalogForCompany,
  error: companies.error
});

export default connect(mapStateToProps)(Services);
